export default __webpack_public_path__ + "static/media/image-slider.974cd61e.png";